import { format, isValid } from 'date-fns'

export const createCaseFlagTimeStamp = (value: string) => {
  const momentDate = new Date(value)
  const day = isValid(momentDate) ? format(momentDate, 'd') : ''
  const month = isValid(momentDate) ? format(momentDate, 'MMM') : ''
  const year = isValid(momentDate) ? format(momentDate, 'yyyy') : ''
  const time = isValid(momentDate) ? format(momentDate, 'h:mma') : ''
  return {
    day,
    month,
    year,
    time,
  }
}
